module.exports = __webpack_public_path__ + "static/bike-zoom-326eb48def9739df015d51a17e610985.jpg";